import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Breadcrumb
} from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder } from 'react-bootstrap-table'

import { browserHistory } from 'react-router'
import Collapsible from './../collapsible'

@observer(['companies', 'globals'])
export default class Leads extends Component {

  constructor(props) {
    super(props)

    this.props.companies.inactive = []
    this.props.companies.loadAllInactive()
  }

  onRowClick(row) {
    browserHistory.push('/companies/' + row.id)
  }

  deleteCompany(id) {
    if (confirm('Are you sure you want to delete this Company?')) {
      this.props.companies.deleteCompany({
        id: id,
        hash: localStorage.getItem('userHash')
      }, () => {
        this.props.companies.loadAllLeads()
      })
    }
  }

  formatActions(cell, row) {
    return (
      <div>
        <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { browserHistory.push('/company/details/' + row.id) } }><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteCompany(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
    )
  }

  render() {
    const options = {
      defaultSortName: 'name',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }

    let inactiveTable = (<a><img src="images/loading.gif" /></a>)

    if (this.props.companies.inactive.length > 0) {
      inactiveTable = (
        <div>
          <BootstrapTable
              data={ this.props.companies.inactive }
              striped={ true }
              hover={ true }
              pagination={ true }
              search={ true }
              exportCSV={ true }
              options={ options }
              bordered={ true }
              >
            <TableHeaderColumn width="100" dataField="name" isKey={ true } dataSort={ true } >Lead</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="fullName" dataSort={ true } >Fullname</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="email" dataSort={ true } >Email</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="phone" dataSort={ true } >Phone</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="address" dataSort={ true } >Address</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="vendorName" dataSort={ true } >Vendor</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="sourceName" dataSort={ true } >Source</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
          </BootstrapTable>
        </div>
      )
    }

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Inactive</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Inactive" content={ inactiveTable } />
        </div>
        <div style={{ clear: 'both' }}></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/companies/inactive.js